"use client";

import { Input } from "@repo/ui/input";
import chroma from "chroma-js";
import { type ChangeEventHandler, useCallback, useRef, useState } from "react";

import { ICON_COLORS } from "./avatar-picker.constants";
import { useAvatarPicker } from "./avatar-picker.context";

export const HexInput = () => {
  const { iconColor, setIconColor } = useAvatarPicker();

  // Only show hex value if it's not one of the preset colors
  const isCustomColor = !ICON_COLORS.includes(iconColor);
  const [localHex, setLocalHex] = useState(
    isCustomColor ? iconColor.toUpperCase() : "",
  );

  const prevColorRef = useRef(iconColor);
  if (prevColorRef.current !== iconColor) {
    prevColorRef.current = iconColor;
    const custom = !ICON_COLORS.includes(iconColor);
    setLocalHex(custom ? iconColor.toUpperCase() : "");
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const raw = e.target.value.replace(/[^A-Fa-f0-9]/g, "").slice(0, 6);
      const display = raw === "" ? "" : `#${raw}`.toUpperCase();
      setLocalHex(display);

      if (chroma.valid(display)) {
        setIconColor(chroma(display).hex());
      }
    },
    [setIconColor],
  );

  return (
    <Input
      value={localHex.replace("#", "").toUpperCase()}
      onChange={handleChange}
      placeholder="#E16540"
      className="w-14 min-w-0 shrink border-none bg-transparent px-0 shadow-none focus-visible:ring-0 dark:bg-transparent"
    />
  );
};
